import { ALL_OPTIONS_VALUE, CUSTOM_OPTIONS_VALUE } from './common';

export const DASHBOARD_DATA_KEYS = {
  PERFORMANCE: 'performance',
  GROWING: 'growing',
  PARTICIPATION: 'participation',
  PROJECT_NAME: 'projectName',
  LAUNCH_DATE: 'launchDate',
  SURVEYS_NUMBER: 'surveysNumber',
};

export const NO_DATA_VALUE_FOR_SORTING = -101;

export const DASHBOARD_PILLAR_TREND = {
  LOWER: 'lower',
  CONSTANT: 'constant',
  HIGHER: 'higher',
};

export const TREND_LINE_LABELS = {
  ALL_TIME: 'All Time',
  FROM_PREVIOUS: 'From Previous',
};

export const CHART_TABLE_CELL_VARIANTS = {
  CIRCLE: 'circle',
  LABEL: 'label',
  TREND: 'trend',
  SCORE: 'score',
};

export const TREND_LINE_DEFINITIONS = {
  ALL_TIME:
    'This trend illustrates the overall trendline for the score across all data sets since the start of the project',
  FROM_PREVIOUS: 'This trend shows you how the score has moved from the previous data set to the current data set',
};

export const DASHBOARD_PILLAR_DEVIATION = {
  SMALL: 'small',
  MEDIUM: 'medium',
  BIG: 'big',
};

export const DASHBOARD_DATA_SETS = {
  CURRENT_DATA_SET: 'current_data_set',
  PREVIOUS_DATA_SET: 'previous_data_set',
  ALL_DATA_SETS: ALL_OPTIONS_VALUE,
  CUSTOM: CUSTOM_OPTIONS_VALUE,
};

const colors1 = ['#e0d2ff', '#6693e9', '#ff8699', '#ac2b95', '#ffb67e', '#c0fa6c', '#cebd9c', '#5bb1c2'];
const colors2 = ['#ff20a9', '#ddff0e', '#720be3', '#c4dfff', '#0800ff', '#00d2dc', '#fbd2dd', '#f4cd59'];
const colors3 = ['#bd67fd', '#fd9a00', '#ffade7', '#54d9ff', '#18e036', '#a1f6e0', '#fad9b3', '#d9cf4d'];
const colors4 = ['#FBEE3D', '#00FFC8', '#B88BC6', '#206B8F', '#FF6E00', '#D500FF', '#00FF61', '#98C7B6'];

export const pillarsColors = [colors1, colors2, colors3, colors4];

export const sampleColors = [
  '#1B5650',
  '#32a096',
  '#52dcc8',
  '#8cffea',
  '#75e7f4',
  '#78c6f4',
  '#B1C9F3',
  '#6199fa',
  '#1266f8',
  '#002080',
];

export const colorsForKeyArea = [
  { backgroundColor: '#DFD3FE', textColor: '#2C2A43' },
  { backgroundColor: '#FF20A9', textColor: '#FFFFFF' },
  { backgroundColor: '#C4DFFF', textColor: '#2C2A43' },
  { backgroundColor: '#C3F877', textColor: '#2C2A43' },
];
